import axiosInstance from '../helpers/axios.helper';
import { colors, borderColors } from '../config/chartColors';
import { DateTime } from 'luxon';
import { DatasetNames } from '../config/industryDatasetNames';

const getDataset = (dates, datasetName, options = {}) => {
  let url;
  switch (datasetName) {
    case DatasetNames.ORDERS_PER_DAY:
      url = 'api/v2/reports/orders/statistics_by_industry';
      break;
    case DatasetNames.AVERAGE_OPTIONS:
      url = 'api/v2/reports/v2_options/average_by_day';
      break;
    case DatasetNames.UNIQUE_CLIENTS:
      url = 'api/v2/reports/v2_options/unique_clients';
      break;
    case DatasetNames.CLOSES_PER_DAY:
      url = 'api/v2/reports/v2_options/closes';
      break;
    case DatasetNames.LEADS_PER_DAY:
      url = 'api/v2/reports/leads/leads_daily_statistics';
      break;
  }
  return axiosInstance.get(url, {params: dates}, options)
    .then(res => parseData(res.data));
};

const parseData = (stats) => {
  return {
    labels: generateDateLabels(stats),
    datasets: generateStackedLineData(stats)
  };
};

const generateDateLabels = (stats) => {
  if (stats[0]) {
    return stats[0].data.map(date => DateTime.fromISO(date.date, {zone: 'utc'}).toLocaleString(DateTime.DATE_SHORT));
  } else {
    return [];
  }
};

const generateStackedLineData = (stats) => {
  return stats.map((industry, index) => {
    return {
      label: industry.industry,
      backgroundColor: colors[index],
      borderColor: borderColors[index],
      data: industry.data.map(date => date.amount)
    };
  });
};

export const industryStatsService = {
  getDataset
};



// WEBPACK FOOTER //
// ./src/services/industryStats.service.js